function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M605.6 569.741a3.9 3.9 0 0 1-.927-.112l-.031-.008-11.513-3.273a.866.866 0 1 1 .474-1.666l11.5 3.268a2.143 2.143 0 0 0 2.576-1.576l2.971-12.154a2.146 2.146 0 0 0-1.573-2.591l-3.161-.772a.866.866 0 0 1 .411-1.683l3.161.773a3.879 3.879 0 0 1 2.844 4.684l-2.971 12.154a3.879 3.879 0 0 1-3.757 2.957z",
    transform: "translate(-588.435 -546.105)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.217 411.242h-10.8a3.88 3.88 0 0 1-3.875-3.875v-12.512a3.88 3.88 0 0 1 3.875-3.875h10.8a3.88 3.88 0 0 1 3.875 3.875v12.512a3.88 3.88 0 0 1-3.875 3.875z",
    style: {
      fill: "currentColor"
    },
    transform: "translate(-381.54 -390.98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.213 15.236a2.4 2.4 0 0 1-2.282-2.5 2.379 2.379 0 0 1 2.292-2.459 2.354 2.354 0 0 1 2.277 2.448 2.4 2.4 0 0 1-2.287 2.511zm-6.554.135a2.093 2.093 0 0 1-1.99-2.188 2.059 2.059 0 0 1 1.99-2.136 2.056 2.056 0 0 1 1.99 2.126 2.09 2.09 0 0 1-1.99 2.199zm-2.344 5.742A1.335 1.335 0 0 1 1.8 19.582v-1.209a4.444 4.444 0 0 1 3.859-2.043 4.088 4.088 0 0 1 2.209.594 4.6 4.6 0 0 0-1.688 3.324 1.566 1.566 0 0 0 .2.865zm4.647 0c-.188-.031-.458-.323-.458-.823 0-1.844 1.824-3.939 4.71-3.939a4.956 4.956 0 0 1 4.283 2.24v.99A1.375 1.375 0 0 1 15 21.113z",
    transform: "translate(.127 -4.071)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.1f4806bd.svg";
export { ForwardRef as ReactComponent };